








import Vue from 'vue'
import { BaseDialog } from '@/components'
import { IParcel } from '../../models'
import { ParcelWidget } from './components'

export default Vue.extend({
    name: 'DialogSelectParcel',

    components: { BaseDialog, ParcelWidget },

    model: {
        prop: 'isShown',
        event: 'update:is-shown',
    },

    props: {
        isShown: {
            type: Boolean,
            required: true,
        },
        parcel: Object as () => IParcel,
    },

    computed: {
        isShownInternal: {
            get(): boolean {
                return this.isShown
            },
            set(isShown: boolean) {
                this.$emit('update:is-shown', isShown)
            },
        },

        parcelInternal: {
            get(): IParcel | undefined {
                return this.parcel
            },
            set(parcel: IParcel) {
                this.$emit('update:parcel', parcel)
            },
        },
    },

    watch: {
        parcelInternal() {
            if (this.isShown) this.submit()
        },
    },

    methods: {
        submit() {
            this.$emit('submit')
            this.isShownInternal = false
        },
    },
})
